import React from "react";
import { ToastContainer } from "react-toastify";

const MainToastContainer = ({ props }) => {
    return (
        <ToastContainer
            position="bottom-right"
            theme="colored"
            autoClose={4000}
            hideProgressBar
            newestOnTop
            pauseOnFocusLoss={false}
            pauseOnHover
            {...props}
        />
    );
};

export default MainToastContainer;
